import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { APP_BASE_HREF, Location } from '@angular/common';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HomeComponent } from './options/home/home.component';
import { SettingsComponent } from './options/settings/settings.component';
import { CustomMaterialModule } from './material.module';
import { AppMaterialModule} from './material-module';
import { BasicAuthInterceptor } from './services/interceptors/basic-auth.interceptor';
import { ErrorInterceptor } from './services/interceptors/error.interceptor';
import { SidenavService} from './services/sidenav.service';
import { AppMapService } from './services/appmap.service';
import { AppMapComponent} from './app-map.component';
import { LoginComponent } from './components/login/login.component';
import { NavbarEventManager } from './_common/NavbarEventManager';
import { ConfirmDialogComponent } from './components/shared/confirmation-dialog/confirmation-dialog.component';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ChartModule } from 'primeng/chart';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { TurboTableKeysDirective } from './directives/turbo-table-keys.directive';
import { MatRowKeyboardSelectionDirective } from './directives/mat-row-keyboard-selection.directive';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DwCalendar } from './custom/dwcalendar/dwcalendar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';

import { getBaseLocation } from './_common/common-functions.util';
import { CodeInputModule } from 'angular-code-input';
import { DragDropModule } from '@angular/cdk/drag-drop';

/*** Billing Components **/
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

/*** User and group management components **/
import { UsermanagementComponent } from './options/settings/usermanagement/usermanagement.component';
import { GeneralsettingsComponent } from './options/settings/generalsettings/generalsettings.component';
import { NotesComponent} from './components/notes/notes.component';

import { DialogModule } from 'primeng/dialog';
import { AboutComponent } from './components/about/about.component';
import { ProfileComponent } from './components/profile/profile.component';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MatDialogModule } from '@angular/material/dialog';

import { NgxColorsModule } from 'ngx-colors';
import { DwStepperComponent } from './custom/dw-stepper/dw-stepper.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history';
import { DwUtils} from './components/utils/dw-utils';
import { DragDropDirective } from './directives/drag-drop.directive';
import { DwTimelineComponent } from './custom/dw-timeline/dw-timeline.component';

import { HomeRendererComponent } from './options/home/home-renderer/home-renderer.component';
import { CardComponent } from './components/card/card.component';
import { MetricCardComponent } from './components/metric-card/metric-card.component';
import { GraphComponent } from './components/graph/graph.component';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { ForgotpasswordComponent } from './components/forgotpassword/forgotpassword.component';
import { AlertDialogComponent } from './components/shared/alert-dialog/alert-dialog.component';

import { ReportsmainComponent } from './options/home/reports/reportsmain/reportsmain.component';
import { ReportRendererComponent } from './options/home/reports/report-renderer/report-renderer.component';
import { ReportRowComponent } from './options/home/reports/report-row/report-row.component';
import { ReportCellComponent } from './options/home/reports/report-cell/report-cell.component';
import { ReportParamsComponent } from './options/home/reports/report-params/report-params.component';
import { SelectuserComponent } from './components/selectuser/selectuser.component';
import { EmailsettingsComponent } from './options/settings/emailsettings/emailsettings.component';

import { SafeHTMLPipe } from './custom/safe-html.pipe';
import { TransactionHistoryMinimalComponent } from './components/transaction-history-minimal/transaction-history-minimal.component';
import {TooltipModule} from 'primeng/tooltip';
import { RegisterUserComponent } from './components/register-user/register-user.component';
import { SendInviteComponent } from './options/settings/usermanagement/send-invite/send-invite.component';
import { DwSplitterComponent } from './custom/dw-splitter/dw-splitter.component';
import { ProgressBarModule} from 'primeng/progressbar';
import {RequestsComponent} from './options/requests/requests.component';
import {AgenciesComponent} from './options/agencies/agencies.component';
import {AgencySettingsComponent} from './options/settings/agencysettings/agencysettings.component';
import {AgencyDefinitionComponent} from './options/agencies/agencydefinition/agencydefinition.component';
import {ServiceSummaryComponent} from './options/agencies/servicesummary/servicesummary.component';
import {ServiceDefinitionComponent} from './options/agencies/servicedefinition/servicedefinition.component';
import {InputMaskModule} from 'primeng/inputmask';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

import {
    TransHistoryDetailComponent
} from './components/transaction-history/trans-history-detail/trans-history-detail.component';
import {AgencyTableComponent} from './options/settings/usermanagement/agencytable/agencytable.component';
import {GlobalSearchComponent} from './options/requests/globalsearch/globalsearch.component';

import {ApproveRequestComponent} from './options/requests/commands/approverequest/approverequest.component';
import { CaseDetailsComponent } from './options/common-tabs/case-details/case-details.component';

import { RegionsComponent } from './options/agencies/servicedefinition/regions/regions.component';
import { MembersComponent } from './options/common-tabs/members/members.component';
import { DwDropdownComponent } from './custom/dw-dropdown/dw-dropdown.component';
import {RequestStatusComponent} from './options/requests/commands/req-status/req-status.component';
import { AddeditmemberComponent } from './options/common-tabs/members/dialogs/addeditmember/addeditmember.component';
import {MatchComponent} from './options/requests/commands/match/match.component';
import {RequestSummaryComponent} from './options/common-tabs/req-summary/req-summary.component';
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from 'ngx-mask';
import { CollaborateRequestComponent } from './options/requests/commands/collaborate-request/collaborate-request.component';

import {DwSpinnerComponent} from './custom/dw-spinner/dw-spinner.component';
import {PastAssistanceComponent} from './options/requests/drawer/pastassistance/pastassistance.component';
import {RequestTypesComponent} from './options/settings/requesttypes/requesttypes.component';
import {RequestStatusesComponent} from './options/settings/requeststatuses/requeststatuses.component';
import {MasterRegionsComponent} from './options/settings/master-regions/master-regions.component';
import {StatusReasonsComponent} from './options/settings/status-reasons/status-reasons.component';
import {UnitOfMeasuresComponent} from './options/settings/unitofmeasures/unitofmeasures.component';
import {NoteCategoriesComponent} from './options/settings/notecategories/notecategories.component';
import { DocumentCategoriesComponent } from './options/settings/document-categories/document-categories.component';

import {MessageDefinitionComponent} from './options/settings/message-definitions/message-defs.component';
import {MessageDetailComponent} from './options/settings/message-definitions/message-detail/message-detail.component';
import {MailMessagesComponent} from './options/requests/drawer/mailmessages/mailmessages.component';
import {NewMessageComponent} from './options/requests/drawer/mailmessages/newmessage/newmessage.component';

import { RequestdetailsComponent } from './options/requests/commands/requestdetails/requestdetails.component';
import { RequestSummaryTabComponent } from './options/requests/tabs/request-summary-tab/request-summary-tab.component';
import { AddNewRequestCompactComponent } from './options/requests/commands/add-new-request-compact/add-new-request-compact.component';


import { MasterQualificationsComponent } from './options/settings/master-qualifications/master-qualifications.component';
import { RequesttypeMasterqualifyMappingComponent } from './options/settings/master-qualifications/drawer/requesttype-masterqualify-mapping/requesttype-masterqualify-mapping.component';
import { MasterqualifyRequesttypeMappingComponent } from './options/settings/requesttypes/drawer/masterqualify-requesttype-mapping/masterqualify-requesttype-mapping.component';
import { CustomQualificationsComponent } from './options/agencies/custom-qualifications/custom-qualifications.component';
import { QualificationResponsesComponent } from './options/common-tabs/qualification-responses/qualification-responses.component';

import {
    ServicedefQualificationsMappingComponent
} from './options/agencies/servicedefinition/dialogs/servicedef-qualifications-mapping/servicedef-qualifications-mapping.component';

import {BannerComponent} from './options/settings/generalsettings/settingsections/banner/banner.component';
import {
    IntegrationComponent
} from './options/settings/generalsettings/settingsections/integration/integration.component';
import {AutomatchComponent} from './options/settings/generalsettings/settingsections/automatch/automatch.component';
import { GlobalsearchCasesComponent } from './options/cases/globalsearch-cases/globalsearch-cases.component';
import {CaseStatusComponent} from './options/cases/commands/case-status/case-status.component';
import {RelationshiptypesComponent} from './options/settings/relationshiptypes/relationshiptypes.component';
import {AddNewCaseComponent} from './options/cases/commands/add-new-case/add-new-case.component';
import {
    ExistingMembersComponent
} from './options/cases/commands/add-new-case/existing-members/existing-members.component';
import { DuplicateMembersComponent } from './options/common-tabs/members/dialogs/duplicate-members/duplicate-members.component';
import {CaseDetailsDialogComponent} from './options/cases/commands/case-details-dialog/case-details-dialog.component';
import {CaseRequestsListComponent} from './options/common-tabs/case-requests-list/case-requests-list.component';
import {CaseDocumentsComponent} from './options/common-tabs/case-documents/case-documents.component';
import {
    AddeditdocumentComponent
} from './options/common-tabs/case-documents/dialogs/addeditdocument/addeditdocument.component';
import {DocpreviewComponent} from './options/common-tabs/case-documents/dialogs/docpreview/docpreview.component';
import {
    CaseavatarpreviewComponent
} from './options/common-tabs/case-documents/dialogs/caseavatarpreview/caseavatarpreview.component';
import {CasesComponent} from './options/cases/cases.component';
import { DuplicateMembersDlgComponent } from './options/common-tabs/members/dialogs/duplicate-members-dlg/duplicate-members-dlg.component';
import {
    EventMessagesComponent
} from './options/settings/generalsettings/settingsections/event-messages/event-messages.component';
import { CheckExtensionPipe } from './pipes/check-extension.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AutomatedEmailsComponent } from './options/settings/automated-emails/automated-emails.component';
import { MessageSuffixesComponent } from './options/agencies/message-suffixes/message-suffixes.component';
import { SurveyEmailsComponent } from './options/settings/generalsettings/settingsections/survey-emails/survey-emails.component';
import { AutoCloseComponent } from './options/settings/generalsettings/settingsections/auto-close/auto-close.component';
import { ModelMessageComponent } from './components/model-message/model-message.component';
import { AdvancedFilterComponent } from './options/home/reports/report-params/dialogs/advanced-filter/advanced-filter.component';
import { UnassignedRequestEmailsComponent } from './options/settings/generalsettings/settingsections/unassigned-request-emails/unassigned-request-emails.component';
import { RecloseDialogComponent } from './components/reclose-dialog/reclose-dialog.component';
import {SecurityComponent} from './options/settings/security/security.component';
import {TreeModule} from 'primeng/tree';
import {TreeTableModule} from 'primeng/treetable';
import {StyleClassModule} from 'primeng/styleclass';
import { SecurityTargetDefinitionsComponent } from './options/settings/security-target-definitions/security-target-definitions.component';
import {SecurityGroupsComponent} from './options/settings/security-groups/security-groups.component';
export function get_settings(appMapService: AppMapService) {
  return () => appMapService.getSettings();
}

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        NavigationComponent,
        HomeComponent,
        NotesComponent,
        LoginComponent,
        SettingsComponent,
        ConfirmDialogComponent,
        TransactionHistoryComponent,
        UsermanagementComponent,
        GeneralsettingsComponent,
        AboutComponent,
        ProfileComponent,
        TurboTableKeysDirective,
        MatRowKeyboardSelectionDirective,
        DwStepperComponent,
        DragDropDirective,
        DwTimelineComponent,
        HomeRendererComponent,
        CardComponent,
        MetricCardComponent,
        GraphComponent,
        MessageBoxComponent,
        ForgotpasswordComponent,
        AlertDialogComponent,
        ReportsmainComponent,
        ReportRendererComponent,
        ReportRowComponent,
        ReportCellComponent,
        ReportParamsComponent,
        SelectuserComponent,
        EmailsettingsComponent,
        DwCalendar,
        DwSplitterComponent,
        SafeHTMLPipe,
        TransactionHistoryMinimalComponent,
        TransHistoryDetailComponent,
        SendInviteComponent,
        RegisterUserComponent,
        RequestsComponent,
        AgenciesComponent,
        AgencySettingsComponent,
        AgencyDefinitionComponent,
        ServiceSummaryComponent,
        ServiceDefinitionComponent,
        AgencyTableComponent,
        RequestsComponent,
        GlobalSearchComponent,
        AddNewCaseComponent,
        ApproveRequestComponent,
        CaseDetailsComponent,
        RegionsComponent,
        MembersComponent,
        DwDropdownComponent,
        RequestStatusComponent,
        AddeditmemberComponent,
        CaseDocumentsComponent,
        AddeditdocumentComponent,
        MatchComponent,
        RequestSummaryComponent,
        CollaborateRequestComponent,
        DocpreviewComponent,
        DwSpinnerComponent,
        PastAssistanceComponent,
        RequestTypesComponent,
        RequestStatusesComponent,
        MasterRegionsComponent,
        StatusReasonsComponent,
        UnitOfMeasuresComponent,
        CasesComponent,
        NoteCategoriesComponent,
        DocumentCategoriesComponent,
        MessageDefinitionComponent,
        MailMessagesComponent,
        MessageDetailComponent,
        NewMessageComponent,
        RequestdetailsComponent,
        RequestSummaryTabComponent,
        AddNewRequestCompactComponent,
        CaseavatarpreviewComponent,
        MasterQualificationsComponent,
        RequesttypeMasterqualifyMappingComponent,
        MasterqualifyRequesttypeMappingComponent,
        CustomQualificationsComponent,
        ServicedefQualificationsMappingComponent,
        QualificationResponsesComponent,
        CaseDetailsDialogComponent,
        BannerComponent,
        IntegrationComponent,
        AutomatchComponent,
        CaseRequestsListComponent,
        GlobalsearchCasesComponent,
        CaseStatusComponent,
        RelationshiptypesComponent,
        ExistingMembersComponent,
        DuplicateMembersComponent,
        DuplicateMembersDlgComponent,
        EventMessagesComponent,
        CheckExtensionPipe,
        SafePipe,
        AutomatedEmailsComponent,
        MessageSuffixesComponent,
        SurveyEmailsComponent,
        AutoCloseComponent,
        ModelMessageComponent,
        AdvancedFilterComponent,
        UnassignedRequestEmailsComponent,
        RecloseDialogComponent,
        SecurityComponent,
        SecurityTargetDefinitionsComponent,
        SecurityGroupsComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        CustomMaterialModule,
        HttpClientModule,
        MatTabsModule,
        AppMaterialModule,
        DialogModule,
        MatDialogModule,
        TableModule,
        CheckboxModule,
        CalendarModule,
        DropdownModule,
        CdkStepperModule,
        ToggleButtonModule,
        InputNumberModule,
        OverlayPanelModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        ChartModule,
        RadioButtonModule,
        CardModule,
        PanelModule,
        ContextMenuModule,
        TooltipModule,
        NgxColorsModule,
        MessageModule,
        MessagesModule,
        ToastModule,
        CodeInputModule,
        ProgressBarModule,
        InputMaskModule,
        NgxMaterialTimepickerModule,
        NgxMaskDirective,
        NgxMaskPipe,
        DragDropModule,
        TreeModule,
        TreeTableModule,
        StyleClassModule,
    ],
    providers: [SidenavService, NavbarEventManager, DwUtils, AppMapComponent, DatePipe, AppMapService, provideNgxMask(),
        [{ provide: LOCALE_ID, useValue: 'en-US' }],
        { provide: APP_INITIALIZER, useFactory: get_settings, deps: [AppMapService], multi: true, },
        { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseLocation
        }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {}
